import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

// Async thunk for sending OTP
export const sendOtp = createAsyncThunk(
  "sendOtp/send",
  async ({ email, full_name, captchaToken }, { rejectWithValue }) => {
    try {
      const response = await post(
        `authn/register/send-otp`,
        {
          email,
          username: email,
          password: "",
          captchaToken,
          fullName: full_name,
        },
        { skipAuth: true },
      )

      return response
    } catch (error) {
      if (error?.code != null && error?.message != null) {
        return rejectWithValue({ code: error.code, message: error.message })
      }
      return rejectWithValue(error?.message)
      // console.error("Failed to send OTP:", error);

      // let raw = error?.message || "";

      // Find JSON part inside the message string
      // const jsonStart = raw.indexOf("{");
      // if (jsonStart !== -1) {
      //   try {
      //     const jsonString = raw.substring(jsonStart);
      //     const parsed = JSON.parse(jsonString);
      //     return rejectWithValue(parsed.message || "Failed to send OTP");
      //   } catch (e) {
      //     console.error("JSON Parse failed:", e);
      //   }
      // }

      // return rejectWithValue("Failed to send OTP");
    }
  },
)

const initialState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  data: null,
  success: false,
  loading: false,
}

const sendOtpSlice = createSlice({
  name: "sendOtp",
  initialState,
  reducers: {
    clearSendOtpState: (state) => {
      state.status = "idle"
      state.error = null
      state.data = null
      state.success = false
      state.loading = false
    },
    clearSendOtpError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.status = "loading"
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.loading = false
        state.data = action.payload
        state.error = null
        state.success = action.payload?.success !== false
      })
      .addCase(sendOtp.rejected, (state, action) => {
      state.loading = false
      state.success = false

      // 👇 IMPORTANT
      state.error =
        action.payload
    })
  },
})

export const { clearSendOtpState, clearSendOtpError } = sendOtpSlice.actions

export const clearSendOtp = clearSendOtpState

export default sendOtpSlice.reducer
